export default __webpack_public_path__ + "media/images/48-01b25fae8d578b0424029db548e193bb.jpg";